import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取锦囊列表
 * @param data
 */
export function getJinNangList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/GoodsProductPage`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊详情
 * @param data
 */
export function getJinNangDetail(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/Summary`,
    method: 'post',
    data
  })
    .then(result => {
      return result.detail
    })
    .catch(() => null)
}

/**
 * 获取锦囊交易动态
 * @param data
 */
export function getJinNangTradePage(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/TradePage`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊仓位详情
 * @param data
 */
export function getJinNangRepoList(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/RepoList`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取锦囊收益曲线
 * @param data
 */
export function getJinNangYieldList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/JinNang/Data/Yieldlist`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
